import api from '../services/api';
import Swal from 'sweetalert2';

export default function Usuarios() {
  const container = document.createElement('div');
  container.className = 'content';

  // Card de título
  const header = document.createElement('div');
  header.className = 'card';
  header.innerHTML = `<h2>Usuários</h2>`;
  container.appendChild(header);

  // Card de ações
  const actions = document.createElement('div');
  actions.className = 'card inline';
  actions.innerHTML = `
    <input id="filtroUser" class="form-input" placeholder="Filtrar por email..." />
    <button id="btnCarregarUser" class="btn btn-sm">Carregar</button>
    <button id="btnNovoUser" class="btn primary btn-sm">Novo</button>
  `;
  container.appendChild(actions);

  // Card da tabela
  const grid = document.createElement('div');
  grid.className = 'card';
  grid.innerHTML = `
    <table class="table">
      <thead>
        <tr>
          <th>Nome</th>
          <th>Email</th>
          <th>Tipo Usuário</th>
          <th>Empresa</th>
          <th>Total terapias</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody id="tbUsuarios"></tbody>
    </table>
  `;
  container.appendChild(grid);

  // Função de carregar lista
  async function carregar() {
    const filtroInput = container.querySelector('#filtroUser');
    const filtro = filtroInput ? filtroInput.value : '';
    try {
      const res = await api.get('/usuarios', { params: { filtro } });
      const tbody = grid.querySelector('#tbUsuarios');
      tbody.innerHTML = res.data.map(u => `
      <tr>
        <td>${u.nome}</td>
        <td>${u.email}</td>
        <td>${u.tipo_descricao}</td>
        <td>${u.empresa_descricao || ''}</td>
        <td>${u.total_terapias || ''}</td>
        <td>
          <button class="btn btn-sm edit" data-id="${u.cod_usuario}">
            <i class="fa-solid fa-pen"></i> Editar
          </button>
          <button class="btn btn-sm link" data-id="${u.cod_usuario}">
            <i class="fa-solid fa-link"></i> Vincular Empresa
          </button>
          <button class="btn btn-sm danger del" data-id="${u.cod_usuario}">
            <i class="fa-solid fa-trash"></i> Excluir
          </button>
        </td>
      </tr>
    `).join('');
      bind();
    } catch (err) {
      console.error('Erro ao carregar usuários:', err);
    }
  }

  // Bind dos botões
  function bind() {
    grid.querySelectorAll('.edit').forEach(b =>
      b.onclick = () => editar(b.getAttribute('data-id'))
    );
    grid.querySelectorAll('.del').forEach(b =>
      b.onclick = () => excluir(b.getAttribute('data-id'))
    );
    grid.querySelectorAll('.link').forEach(b =>
      b.onclick = () => vincular(b.getAttribute('data-id'))
    );
  }

  async function vincular(cod_usuario) {
  const empresas = (await api.get('/empresas')).data;

  Swal.fire({
    title: 'Vincular Empresa',
    html: `
      <form id="fLink">
        <label>
          Empresa
          <select name="cod_empresa" class="swal2-input">
            ${empresas.map(e => `
              <option value="${e.cod_empresa}">${e.descricao}</option>
            `).join('')}
          </select>
        </label>
      </form>
    `,
    showCancelButton: true,
    confirmButtonText: 'Salvar',
    preConfirm: async () => {
      const fd = new FormData(document.getElementById('fLink'));
      const payload = Object.fromEntries(fd.entries());
      payload.cod_usuario = cod_usuario;
      try {
        await api.post('/usuariosempresas', payload);
        carregar();
      } catch (err) {
        Swal.showValidationMessage(err.response?.data?.message || 'Erro ao vincular');
        return false;
      }
    }
  });
}

  // Excluir usuário
  async function excluir(id) {
    const result = await Swal.fire({
      title: 'Excluir usuário?',
      text: 'Essa ação não poderá ser desfeita!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Sim, excluir',
      cancelButtonText: 'Cancelar'
    });
    if (!result.isConfirmed) return;
    await api.delete(`/usuarios/${id}`);
    Swal.fire({ title: 'Excluído!', icon: 'success', showConfirmButton: false, timerProgressBar: false });
    carregar();
  }

  // Formulário de edição/criação
  async function editar(id) {
  const user = id ? (await api.get('/usuarios')).data.find(x => x.cod_usuario === id) : null;
  const tipos = (await api.get('/tiposusuario')).data;

  Swal.fire({
    timerProgressBar: false,
    title: id ? 'Editar Usuário' : 'Novo Usuário',
    html: `
      <form id="fUser" style="display:flex;flex-direction:column;gap:6px;text-align:left;">
        <label style="display:flex;flex-direction:column;gap:5px;">
          Nome
          <input name="nome" value="${user?.nome || ''}" required class="swal2-input" style="margin:0;" />
        </label>
        <label style="display:flex;flex-direction:column;gap:5px;">
          Email
          <input name="email" value="${user?.email || ''}" required class="swal2-input" style="margin:0;" />
        </label>
        <label style="display:flex;flex-direction:column;gap:5px;">
          Senha
          <input name="senha" type="password" value="${user?.senha || ''}" required class="swal2-input" style="margin:0;" />
        </label>
        <label style="display:flex;flex-direction:column;gap:5px;">
          Tipo Usuário
          <select name="cod_tipo_usuario" required class="swal2-input" style="margin:0;">
            ${tipos.map(t => `
              <option value="${t.cod_tipo_usuario}" ${user?.cod_tipo_usuario === t.cod_tipo_usuario ? 'selected' : ''}>
                ${t.descricao}
              </option>
            `).join('')}
          </select>
        </label>
      </form>
    `,
    focusConfirm: false,
    showCancelButton: true,
    confirmButtonText: 'Salvar',
    cancelButtonText: 'Cancelar',
      preConfirm: async () => {
        const fd = new FormData(document.getElementById('fUser'));
        const payload = Object.fromEntries(fd.entries());
        try {
          if (id) {
            await api.put(`/usuarios/${id}`, payload);
          } else {
            await api.post('/usuarios', payload);
          }
          carregar();
        } catch (err) {
          // pega a mensagem que o servidor retornou
          const msg = err.response?.data?.message || 'Erro ao salvar usuário';
          // mostra no modal, logo abaixo do botão "Salvar"
          Swal.showValidationMessage(msg);
          // não precisa lançar erro, o SweetAlert já impede o fechamento
          return false;
        }
      }
  });
}


  // Botões principais
  actions.querySelector('#btnCarregarUser').onclick = carregar;
  actions.querySelector('#btnNovoUser').onclick = () => editar();

  carregar();
  return container;
}
